import { registerPwa } from '@/lib/registerPwa'

registerPwa()

/**
 * Bootstrap: load the full app when the route needs it.
 *
 * - Non-home routes always load the app (sign-in, dashboard, etc.).
 * - Home (/) normally loads only the static HTML shell for a lighter first visit.
 * - If localStorage already holds a Supabase session key, we load the app on `/`
 *   as well so a full reload keeps the signed-in shell (Supabase restores from
 *   storage only when our client runs).
 */
function pathnameNormalized(): string {
  return window.location.pathname.replace(/\/$/, '') || '/'
}

function hasSupabaseAuthInLocalStorage(): boolean {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      // GoTrue default: sb-<project-ref>-auth-token
      if (key?.startsWith('sb-') && key.endsWith('-auth-token')) {
        return true
      }
    }
  } catch {
    // Storage blocked or unavailable — load app so we never strand a user on static HTML
    return true
  }
  return false
}

const pathname = pathnameNormalized()
if (pathname !== '/' || hasSupabaseAuthInLocalStorage()) {
  import('./main.tsx')
}
